import { FiEdit, FiDelete } from "react-icons/fi";
import {AiFillDelete,AiFillEdit} from 'react-icons/ai'

import style from "../style/card.module.css";

import { conveterParaMonetario } from "../function/funcionalidades";

export default function Card({ title, valor, mes,onPressDelete,onPressEdit}) {
  function colorButtonCard(){
    return style.botao
  }
  return (
    <div className={style.container}>
      <div>
        <p className={style.title}>{title}</p>
        <div className={style.subContainer}>
          <p className={style.subTitle}>{valor}</p>
          {
            mes && <p className={style.subTitle}>{"- " + mes}</p>
          }

        </div>
      </div>
      <div className={style.botoes}>
        <AiFillEdit size={20} color="#292828"   cursor="pointer" onClick={onPressEdit} />
        <AiFillDelete size={20} color="#292828" cursor="pointer" onClick={onPressDelete}/>
      </div>
    </div>
  );
}
